export const ACNT_APP_CONSTANT = {
  app_name: 'ACNT',
  app_type: 'INTERNAL',
};
